var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FListbox',{attrs:{"value":_vm.value,"focus-item-on-focus":true,"data":_vm.resolutions,"labeled-by":_vm.labeledBy,"horizontal":""},on:{"change":function($event){return _vm.$emit('change', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }